/// <reference path="../../Common/Base/SiteEntityGrid.ts" />

namespace Matrix.Data {
    
    @Serenity.Decorators.registerClass()
    export class SecurityTypeGrid extends SiteEntityGrid<SecurityTypeRow, any> {
        protected getColumnsKey() { return 'Data.SecurityType'; }
        protected getDialogType() { return SecurityTypeDialog; }
        protected getIdProperty() { return SecurityTypeRow.idProperty; }
        protected getLocalTextPrefix() { return SecurityTypeRow.localTextPrefix; }
        protected getService() { return SecurityTypeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}